module.exports = {
  mainContent: 'content',
  locationCardListTitle: 'locationCardListTitle',
};
